<template>
  <div class="login  text-center">
    <div class="login-content">
      <h1 class="margin-b-15">九江电子商务大数据系统</h1>
      <p class="text-A6E7FF margin-b-40 font-18">JIUJIANG E-COMMERCE BIG DATA SYSTEM</p>
      <el-form :model="loginInfo" :rules="loginRules" ref="loginInfo" class="">
        <div>
<!--          <h2>用户登录</h2>-->
          <el-form-item label="" prop="username" class="margin-b-35 margin-t-20">
            <el-input type="text" placeholder="请输入账号" prefix-icon="el-icon-s-custom"
                      v-model="loginInfo.username" v-on:keyup.enter.native="login('loginInfo')">
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" v-model="loginInfo.password"
                      v-on:keyup.enter.native="login('loginInfo')">
            </el-input>
          </el-form-item>
          <el-form-item label=""  prop="code" class="code">
            <el-input v-model="loginInfo.code" placeholder="请输入右侧验证码"  style=" width: 70%; float:left;"></el-input>
            <div class="get-code" @click="refreshCode()">
              <s-identify :identifyCode="identifyCode"></s-identify>
            </div>
          </el-form-item>
          <el-button class="login-button" v-on:click="login('loginInfo')"  @click="handleSubmit" >登录</el-button>
        </div>

        <!--          <div class="text-left go-register">还没有账号？<a href="./#/register">立即申请!</a></div>-->
      </el-form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import SIdentify from "@/components/SIdentify.vue";
  export default {
    name: 'login',
    components: { SIdentify },
    data () {
      //验证码校验
      const identifyCode = (rule, identifyCodes, callback) => {
        if (identifyCodes === '') {
          callback(new Error('请输入验证码！'));
        } else if (identifyCodes.toLowerCase() !== this.identifyCode.toLowerCase()){
          callback(new Error('验证码错误！'));
        } else {
          callback();
        }
      };
      return {
        identifyCode: "", //输入的code
        identifyCodes: "123456789abcdwerwshdjeJKDHRJHKPLMKQ",//绘制的随机数code
        loginInfo: {
        },
        checked: '',
        loginRules: {
          username: [
            {required: true, message: '请输入账号！', trigger: 'change'}
          ],
          password: [
            {required: true, message: '请输入密码！', trigger: 'change'}
          ],
          code: [
            { validator: identifyCode, trigger: 'blur' }
          ],
        },
      }
    },
    created: function () {
      this.$emit('public_header', false),
        this.refreshCode();
    },

    methods: {
      refreshCode() {
        this.identifyCode = '';
        console.log(this.identifyCode)
        this.makeCode(this.identifyCodes, 4);
      },
      randomNum(min, max) {
        max = max + 1
        return Math.floor(Math.random() * (max - min) + min)
      },
      // 随机生成验证码字符串
      makeCode(data, len) {
        for (let i = 0; i < len; i++) {
          this.identifyCode += data[this.randomNum(0, data.length - 1)]
        }
      },

      login (loginInfo) {
        this.$refs[loginInfo].validate((valid) => {
          // Object.assign(loginInfo[0], {role: admin})
          if (valid) {
            this.loginInfo.password = this.$md5(this.loginInfo.password);
            this.$http.post(this.header + '/login/loginCheck',JSON.stringify(this.loginInfo)).then(res => {
              if (res.data.code == 0) {
                // this.GLOBAL.userInfo = res.data.info;
                let userInfo = JSON.stringify(this.loginInfo)
                // console.dir(userInfo)
                sessionStorage.setItem('userInfo', userInfo)
                sessionStorage.setItem('xybdsToken', res.data.xybdsToken)
                this.$router.push({path: '/index'})
                // console.dir(sessionStorage.getItem('userInfo'))
                this.refreshCode();
              } else {
                  this.refreshCode();
                this.$alert(res.data.msg)
              }

            })
          } else {
            return false
          }
        })
      },
      //登录
      submit(){
        this.$refs.form.validate((valid) => {
          if(valid){
            getMenu(this.form).then(({ data }) => {
              console.log(data)
              if(data.code === 20000){

                //获取菜单的数据存入store中
                this.$store.commit('setMenu',data.data.menu)

              }else{
                this.$message.error(data.data.message)
              }
            })
          }
        })
      },
      handleSubmit(ev) {
        const _this = this;
        _this.$refs.loginInfo.validate((valid) => {
          if (valid) {
            _this.logining = true;
            const loginParams = {
              username: this.loginInfo.username,
              password: this.loginInfo.password
            };
            loginParams.role = 'admin';
            if (loginParams.username == 'xj' && loginParams.password == 'xj123456' ) {
              if (loginParams.role === 'superadmin') {
                window.localStorage.setItem('roles','superadmin')
              } else if (loginParams.role === 'admin') {
                window.localStorage.setItem('roles','admin')
              } else if (loginParams.role === 'user') {
                window.localStorage.setItem('roles','user')
              }
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }

  }
</script>

<style>


  .login .el-input__icon {
    font-size: 26px;
    width: 45px;
    color: #20A3F5;
  }


  .login .el-input__inner {
    background-color: rgba(24,136,203,0.3) !important;
    border:3px solid rgba(32,163,245,0.4) !important;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    color: white;
  }

  .login {
    background: url("../assets/login-bg.png") no-repeat 100% 100% !important;
    background-size: 100% 100% !important;
    padding-top: 80px;
    padding-bottom: 237px !important;
    margin-left: 0px !important;
  }


  @media screen and (max-width: 1280px) {
    .login .login-content {
      width: 631px;
      margin-top: 40px;
      margin-left: 23%;

    }
  }

  @media screen and (min-width: 960px) and (max-width: 1200px) {
    .index {
      /*width: 770px;*/
    }
  }

  @media screen and (min-width: 1300px) and (max-width: 1600px) {
    .login .login-content {
      width: 631px;
      margin-top: 60px;
      margin-left: 42%;

    }
  }

  @media screen and (min-width: 1600px) {
    .login .login-content {
      width: 631px;
      margin-top: 40px;
      margin-left: 40%;

    }
  }

  @media screen and (min-width: 1900px) {
    .login .login-content {
      width: 631px;
      margin-top: 100px;
      margin-left: 32%;

    }
  }
  .login .login-content h1 {
    background: linear-gradient(0deg, rgba(0, 159, 241, 1) 0%, rgba(0, 232, 207, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size:41px;
  }

  .login form h2 {
    color: rgba(0, 191, 244, 1);
    text-align: center;
    padding-top: 30px;
  }

  .login form {
    width: 631px;
    height: 500px;
    padding: 80px 100px 0 100px;
    /*background-color: ;*/
    background:url("../assets/login-content-bg.png") no-repeat 100% 100%;
    background-size: 100% 100% !important;

  }
  /*.login .login-form-border{*/
  /*  border: 3px rgba(32,163,245,0.5) solid;*/
  /*  height: 100%;*/
  /*}*/
  .login-left p {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #0D388F;
  }

  .login .el-input--prefix .el-input__inner {
    padding-left: 50px;
  }

  .login .el-input {
    width: 100%;
    height: 50px;

  }

  .login .login-button {
    width:100%;
    height:50px;
    background:rgba(32,163,245,1) !important;
    border-radius:2px;
    font-size: 26px;
    color: white !important;
    /*margin-top: 40px;*/
    border: none;
  }

  .login-button .el-button:focus, .login-button .el-button:hover {
    background: linear-gradient(90deg, rgba(111, 178, 255, 1), rgba(9, 95, 255, 1)) !important;
    color: white !important;
  }
  .code ::v-deep .el-input__inner{
    width: 313px!important;
  }
  .code-img {
    width: 30%;
    height: 50px;
    float: right;
    margin-top: -65px;
    margin-right: 270px;
    text-align: center;
    background: #dbdbdb;
  }
  .login .el-form-item__error {
    padding-top: 10px!important;
    margin-left: 50px;
  }
  .code .el-form-item__error {
    padding-top: 0px!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/login.vue